






import { Component, Prop, Mixins } from 'vue-property-decorator'
import InputWithValidation from '@/mixins/InputWithValidation'

@Component
export default class VSelectWithValidation extends Mixins(InputWithValidation) {
  @Prop()
  public errorMessages!: string
}
